const dateRangeValueTemplate = {
  data: '',
  label: '',
  count: 0,
  queryStringParam: '',
  constraint: '',
  selected: false,
  queryStringParamName: '',
  queryStringParamValue: '',
  toggleUrl: '',
};

const dateRangeFacetTemplate = {
  name: '',
  unselectAllUrl: '',
  selectionType: 'SINGLE',
  constraintJoin: 'AND',
  order: [''],
  facetValues: '',
  guessedDisplayType: 'DATE_RANGE',
  categories: [],
  customData: {},
  allValues: [],
  selectedValues: [],
  selected: false,
};

const receivedDateStartFacet = {
  ...dateRangeFacetTemplate,
  name: 'Date received__start',
  categories: [
    {
      queryStringParamName: 'ge_applicationReceivedDateFB|dateReceived__start',
      values: [{ ...dateRangeValueTemplate }],
    },
  ],
};

const receivedDateEndFacet = {
  ...dateRangeFacetTemplate,
  name: 'Date received__end',
  categories: [
    {
      queryStringParamName: 'le_applicationReceivedDateFB|dateReceived__end',
      values: [{ ...dateRangeValueTemplate }],
    },
  ],
};

const decisionDateStartFacet = {
  ...dateRangeFacetTemplate,
  name: 'Date of decision__start',
  categories: [
    {
      queryStringParamName: 'ge_determinationdateOfDecisionFB|dateDecision__start',
      values: [{ ...dateRangeValueTemplate }],
    },
  ],
};

const decisionDateEndFacet = {
  ...dateRangeFacetTemplate,
  name: 'Decision date__start',
  categories: [
    {
      queryStringParamName: 'le_determinationdateOfDecisionFB|dateDecision__end',
      values: [{ ...dateRangeValueTemplate }],
    },
  ],
};

const resolveFacets = (facets, collection) => {
  if (facets && ['delwp-planning-ministerial-permits-stage', 'delwp-planning-ministerial-permits-prod'].includes(collection)) {
    const newFacets = [];

    for (const facet of facets) {
      if (facet.guessedDisplayType === 'CHECKBOX') {
        newFacets.push(receivedDateStartFacet, receivedDateEndFacet, decisionDateStartFacet, decisionDateEndFacet);
      }
      newFacets.push(facet);
    }
    // Define the desired order of names
    const desiredOrder = ['Decision', 'Date of decision__start', 'Decision date__start', 'Type', 'Date received__start', 'Date received__end', 'Status'];

    // Create a mapping of names to their original positions
    const nameToPosition = {};
    newFacets.forEach((item, index) => {
      nameToPosition[item.name] = index;
    });

    // Sort the data based on the desired order
    const rearrangedData = desiredOrder.map((name) => newFacets[nameToPosition[name]]);

    return rearrangedData;
  }
  return facets || [];
};

export default resolveFacets;
